/**
 * ## Payment Types
 * 
 * @type { PUSH | QRCODE }
 * 
 * @author Pedro Neves
 */
export enum PaymentType{

    /**
     * **Push** - When Payment will send a Push-Notification to the users phone
     */
    PUSH = "push",


    /**
     * **QrCode** - When Payment will generate a QrCode id
     */
    QRCODE = "qrcode"

}